module.exports = __webpack_public_path__ + "static/servicios-otros-icon-5f016ff057d267d30bec1290f70b70e6.png";